import { useState } from "react";
import type { Episode } from "@/types";

export default function DemoPlayer({ episode }: { episode: Episode }) {
  const [started, setStarted] = useState(false);

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-primary-950">
      <div className="relative aspect-video w-full">
        <img
          src={episode.cover}
          alt={`出轨同学会第${episode.number}集《${episode.title}》剧照`}
          title={`出轨同学会 第${episode.number}集 剧照`}
          className="h-full w-full object-cover object-top opacity-70"
        />
        <div className="absolute inset-0 bg-primary-950/55"></div>

        <span className="absolute left-3 top-3 rounded bg-primary-900/85 px-2 py-0.5 font-label text-[11px] leading-tight text-background-50">
          第 {episode.number} 集 · {episode.duration}
        </span>

        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center">
          {started ? (
            <>
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-primary-950">
                <i className="ri-error-warning-line text-xl leading-none"></i>
              </span>
              <p className="font-heading text-base font-semibold text-background-50">演示模式</p>
              <p className="max-w-md font-label text-sm leading-relaxed text-background-300">
                本站为影视资料演示站点，不提供真实视频播放。你可以继续浏览下方的剧情介绍与主演信息。
              </p>
              <button
                type="button"
                onClick={() => setStarted(false)}
                className="mt-1 whitespace-nowrap rounded-md border border-background-50/40 px-4 py-1.5 font-label text-xs text-background-50 transition-colors hover:bg-background-50/10"
              >
                返回剧照
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                aria-label="播放（演示）"
                onClick={() => setStarted(true)}
                className="flex h-16 w-16 items-center justify-center rounded-full bg-background-50/90 text-primary-800 transition-transform hover:scale-105"
              >
                <i className="ri-play-fill text-3xl leading-none"></i>
              </button>
              <p className="font-label text-sm text-background-200">点击播放（演示）</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}